export default __webpack_public_path__ + "static/media/duitnow.f44559a8.svg";